<p-dialog [(visible)]="displaySendEmailTemplate" [focusTrap]="false" styleClass="sendEmail body-p-dialog" [closable]="false"
[modal]="true" [responsive]="true" [style]="{width: '75vw', height:'85vh'}" [showHeader]="false" appendTo="body">
    <ng-template pTemplate="content">
        <div style="position: relative;">
            <div class="tabviewIcons">
                <p-button (click)="checkConfigurationAndPerformOps()" label="Sign Out"></p-button>
            </div>
            <p-tabView [(activeIndex)]="selectedIndex" (onChange)="handleChange($event)">
                <p-tabPanel [selected]="activeIndex === 0" >
                    <ng-template pTemplate="header">
                        <div class="p-d-flex p-ai-center">
                            <span>E-mail</span>
                        </div>
                    </ng-template>
                    <ng-container *ngIf="emailTemp && flag == '' ">
                        <app-lion-email-compose-form
                            #composeForm
                            [emailAudit]="emailTemp.emailAudit"
                            [contacts]="contacts"
                            action="compose"
                            [channelId]="channelId"
                            [objectTypeId]="objectTypeId"
                            [objectId]="objectId"
                        >
                        </app-lion-email-compose-form>
                    </ng-container>
                    <ng-container *ngIf="emailTemp && flag != '' ">
                        <app-lion-email-compose-form
                            #composeForm
                            [emailAudit]="emailAudit"
                            [flag]="flag"
                            [emailThread]="thread"
                            [channelId]="channelId"
                            [objectTypeId]="objectTypeId"
                            [objectId]="objectId"
                        >
                        </app-lion-email-compose-form>
                    </ng-container>
                    <ng-template pTemplate="footer" *ngIf="flag == '' ">
                        <div class="p-field p-mb-0 p-formgrid p-grid">
                            <div class="p-col-1">
                                <label>Options</label>
                            </div>
                            <div class="p-col-4">
                                <p-dropdown appendTo="body"
                                    [disabled]="emailTemp.emailAudit.emailThreads[0].isDraft"
                                    [options]="options"
                                    [(ngModel)]="selectedOption"
                                    optionLabel="name">
                                </p-dropdown>
                            </div>
                            <div class="p-col-4" *ngIf="selectedOption.code === 'schedule'">
                                <p-calendar [(ngModel)]="emailTemp.emailAudit.scheduledDate" (onChange)="scheduledDateCheck()" placeholder="Select a date" [minDate]="minimumDate"
                                    [showIcon]="true" appendTo="body" showTime="true" hourFormat="12"></p-calendar>
                                <small *ngIf="(!emailTemp?.emailAudit?.scheduledDate) && scheduledDateRequired" class="p-invalid">Scheduled Date required</small>
                            </div>

                            <div class="p-text-right"
                                [ngClass]="{'p-col-8': selectedOption.code !== 'schedule', 'p-col-4': selectedOption.code === 'schedule'}">
                            </div>
                        </div>
                        <div *ngIf="selectedOption.code === 'saveastemplate'" class="p-field p-mt-2 p-formgrid p-grid">
                            <div class="p-col-1">
                                <label>Template Name</label>
                            </div>
                            <div class="p-col-4" >
                                <input type="text" [(ngModel)]="emailTemplateName" id="emailTemplateName" name="emailTemplateName" pInputText required="true"
                                [formControl]="emailTemplateNameControl" required/>
                                <small *ngIf="(!emailTemplateName?.length > 0) && emailTemplateNameRequired" class="p-invalid">Template name required</small>
                                <small *ngIf="!emailTemplateNameValid" class="p-invalid">Template name exist.</small>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <p-tabPanel #draft *ngIf="flag == '' ">
                    <ng-template pTemplate="header">
                        <div class="p-d-flex p-ai-center">
                            <span class="p-mr-1">Draft</span>
                            <i class="pi loading-spinner pi-sync p-ml-2"
                                style="font-size: 1rem"
                                *ngIf="draftedEmailsLoading" tooltipPosition="top" pTooltip="loading...">
                            </i>
                            <span *ngIf="!draftedEmailsLoading">
                                ({{ draftedEmailsLength }})
                            </span>
                        </div>
                    </ng-template>
                    <div class="p-grid" *ngFor="let emailObj of draftedEmails; let i = index;">
                        <div class="p-col-12">
                            <p-card class="activity-card">
                                <div class="p-d-flex">
                                    <div class="activity-icon bg-email p-shadow-3">
                                        <span class="pi pi-envelope"></span>
                                    </div>
                                    <div class="activity-content">
                                        <div class="cursor-pointer" (click)="openInComposeEmail(emailObj)">
                                            <h6 class="p-mb-1" style="display: inline-block;">
                                                Email - E-mail to <span class="highlight">{{ emailObj.emailThreads[0].emailRecipients[0]?.emailAddress }}</span>
                                            </h6>
                                            <span class="p-ml-4">
                                                {{ emailObj.createdDate | localDate:'MM/DD/YYYY | h:mm a' }}
                                            </span>
                                        </div>
                                        <div class="cursor-pointer" style="float: right;" (click)="deleteMail(emailObj, 'draft')">
                                            <i class="pi pi-trash"></i>
                                        </div>
                                        <div>{{ emailObj.emailThreads[0].subject }}</div>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                    <!-- <div class="p-grid" [ngClass]="{ 'p-pt-2': i !== 0 }"
                        *ngFor="let emailObj of draftedEmails; let i = index;"
                        (click)="openInComposeEmail(emailObj)">
                        <div class="p-col-1 p-pr-0">
                            <img src="./assets/images/email_draft.png" alt="Draft Email Icon" />
                        </div>
                        <div class="p-col p-lg-11 p-md-11 " >
                            <h6 class="p-mb-1 selectionHand">
                                Email - E-mail to <span class="highlight">{{ emailObj.emailThreads[0].emailRecipients[0]?.emailAddress }}</span>
                                <span class="pull-right">
                                    {{ emailObj.createdDate | localDate }}
                                </span>
                            </h6>
                            <p>{{ emailObj.emailThreads[0].subject }}
                            </p>
                        </div>
                    </div> -->
                    <div *ngIf="draftedEmails.length ==0">
                        <p>No records found </p>
                    </div>

                </p-tabPanel>
                <p-tabPanel #scheduled *ngIf="flag == '' ">
                    <ng-template pTemplate="header">
                        <div class="p-d-flex p-ai-center">
                            <span class="p-mr-1">Scheduled</span>
                            <i class="pi loading-spinner pi-sync p-ml-2"
                                style="font-size: 1rem"
                                *ngIf="scheduledEmailsLoading" tooltipPosition="top" pTooltip="loading...">
                            </i>
                            <span *ngIf="!scheduledEmailsLoading">
                                ({{ scheduledEmailsLength }})
                            </span>
                        </div>
                    </ng-template>
                    <div class="p-grid" *ngFor="let emailObj of scheduledEmails; let i = index;">
                        <div class="p-col-12">
                            <p-card class="activity-card">
                                <div class="p-d-flex">
                                    <div class="activity-icon bg-email p-shadow-3">
                                        <span class="pi pi-envelope"></span>
                                    </div>
                                    <div class="activity-content">
                                        <div class="cursor-pointer" (click)="openInComposeEmail(emailObj)">
                                            <h6 class="p-mb-1" style="display: inline-block;">
                                                Email - E-mail to <span class="highlight">{{ emailObj?.emailThreads[0].emailRecipients[0]?.emailAddress }}</span>
                                            </h6>
                                            <span class="p-ml-4">
                                                {{ emailObj?.createdDate | localDate:'MM/DD/YYYY | h:mm a' }}
                                            </span>
                                            <span class="p-ml-4" *ngIf="emailObj?.scheduledDate">
                                                Schedule Date:
                                                {{ emailObj?.scheduledDate | localDate:'MM/DD/YYYY | h:mm a' }}
                                            </span>
                                        </div>
                                        <div class="cursor-pointer" style="float: right;" (click)="deleteMail(emailObj, 'schedule')">
                                            <i class="pi pi-trash"></i>
                                        </div>
                                        <div>{{ emailObj?.emailThreads[0].subject }}</div>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <!-- <button type="button" pButton *ngIf="selectedIndex == 0" (click)="clearSendComposeForm()" label="Reset" class="p-button-secondary"></button> -->
        <button type="button" pButton (click)="cancel()" label="Cancel" class="p-button-secondary"></button>
        <!-- <button type="button" pButton *ngIf="flag != '' " (click)="cancelEmailDetails()" label="Cancel EL" class="p-button-secondary"></button> -->
        <button type="button" [disabled]="savingSendMail" *ngIf="selectedIndex !==1 && selectedIndex !== 2  && flag == '' && selectedOption.code !=='saveastemplate'" (click)="openEmailTemplatePreview()" class="p-ml-2" pButton label="Preview"> </button>
        <button type="button" [disabled]="savingSendMail" *ngIf="selectedIndex !==1 && selectedIndex !== 2  && flag == '' && selectedOption.code !=='saveastemplate'" (click)="sendMail(selectedOption.code)" class="p-ml-2" pButton label="{{ selectedIndex == 0 ? (selectedOption.code ==='draft' || selectedOption.code === 'schedule' ? 'Save' : 'Send') : 'Save' }}"> </button>
        <button type="button" *ngIf="selectedIndex !==1 && selectedIndex !== 2 && flag != '' && selectedOption.code !=='saveastemplate'" (click)="sendMailFromActivity()" class="p-ml-2" pButton label="{{ selectedIndex == 0 ? (selectedOption.code ==='draft' || selectedOption.code === 'schedule'? 'Save' : 'Send') : 'Save' }}"> </button>
        <button type="button" *ngIf="selectedIndex !==1 && selectedIndex !== 2  && selectedOption.code ==='saveastemplate'" (click)="saveAsEmailTemplate()" class="p-ml-2" pButton label="Save"> </button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayConfigureEmail" (onHide)="cancel()" header="Configure Email" class="configureEmail"
    [modal]="true" [style]="{width: '50em'}">
    <div class="p-grid w-100">
        <ng-container *ngFor="let client of mailClients">
            <div class="p-col p-sm-12 p-md-12 p-lg-4 p-text-center">
                <h5>
                    <div *ngIf="client.name === 'Other SMTPs'; then thenBlock; else elseBlock"></div>
                    <ng-template #thenBlock>
                        <a title="Comming Soon" class='pointer' style="color: rgb(73 80 87);" (click)="configureSMTP(client)">
                            <img [src]="client.image" [alt]="client.name" />
                            <div>{{ client.name }}</div>
                        </a>
                    </ng-template>
                    <ng-template #elseBlock>
                        <a class='pointer' style="color: rgb(73 80 87);" (click)="configureEmail(client)">
                            <img [src]="client?.image" [alt]="client.name"
                            [ngStyle]="client.name == 'Gmail' && {'margin-top': '12%', 'margin-bottom': '12%'}" />
                            <div>{{ client.name }}</div>
                        </a>
                    </ng-template>
                </h5>
            </div>
        </ng-container>
    </div>
</p-dialog>

<p-dialog [(visible)]="displayEmailPreview" (onHide)="closePreview()" header="Email Preview" [modal]="true" [style]="{width: '60vw'}">
    <div class="w-100">
        <div class="email-subject card">
            <div class="email-subject-label p-mb-2"><strong> Subject:</strong></div>
            <div class="email-subject-text">{{ emailPreviewResponse?.subject }}</div>
        </div>
        <div class="email-body card">
            <div class="email-body-label p-mb-2"><strong> Body:</strong></div>
            <div class="email-subject-text" [innerHTML]="sanitizer.bypassSecurityTrustHtml(emailPreviewResponse?.content||'')"></div>
        </div>
    </div>
</p-dialog>

<!-- <p-confirmDialog key="confirm-delete-draft-schedule-mail22" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog> -->

<!-- IMAP Taylor Design  -->
<!-- <p-dialog [(visible)]="displaySMTPConfig" header="IMAP Account Settings" [modal]="true" [style]="{width: '45vw'}">
    <div class="header p-d-flex p-jc-between">
        <h6 class="p-mb-0">abcsd&#64;liono.com</h6>
        <a (click)="changeUser()" class="pointer">(Not you?)</a>
    </div>
    <div class="card">
        <p-panel header="Incoming mail">
            <div class="p-grid">
                <div class="p-col-12 p-md-8">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Server</label>
                        <input type="text" pInputText />
                    </div>
                    <div class="p-d-flex p-mt-2">
                        <label class="p-mr-2 w-100">Encryption method</label>
                        <p-dropdown appendTo="body"
                            [options]="encryption" class="w-100"
                            [(ngModel)]="selectedEncryption"
                            optionLabel="name">
                        </p-dropdown>
                    </div>
                </div>
                <div class="p-col-12 p-md-4">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Port</label>
                        <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="p-col-12">
                    <div class="p-d-flex">
                        <p-checkbox value="incoming logon" inputId="incoming" [(ngModel)]="incomingChecked" [binary]="true" />
                        <label for="incoming" class="p-ml-2">Require logon using Secure Password Authentication (SPA)</label>
                    </div>
                </div>
                <ng-container *ngIf="incomingChecked">
                    <div class="p-col-12">
                        <div class="p-d-flex">
                            <label class="p-mr-2">Username</label>
                            <input type="text" pInputText />
                        </div>
                        <div class="p-d-flex p-mt-2">
                            <label class="p-mr-2">Password</label>
                            <input type="text" pInputText />
                        </div>
                    </div>
                </ng-container>
            </div>
        </p-panel>
        <p-panel header="Outgoing mail">
            <div class="p-grid">
                <div class="p-col-12 p-md-8">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Server</label>
                        <input type="text" pInputText />
                    </div>
                    <div class="p-d-flex p-mt-2">
                        <label class="p-mr-2 w-100">Encryption method</label>
                        <p-dropdown appendTo="body"
                            [options]="encryption" class="w-100"
                            [(ngModel)]="selectedEncryption"
                            optionLabel="name">
                        </p-dropdown>
                    </div>
                </div>
                <div class="p-col-12 p-md-4">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Port</label>
                        <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="p-col-12">
                    <div class="p-d-flex">
                        <p-checkbox value="incoming logon" inputId="incoming" [(ngModel)]="outgoingChecked" [binary]="true" />
                        <label for="incoming" class="p-ml-2">Require logon using Secure Password Authentication (SPA)</label>
                    </div>
                </div>
                <ng-container *ngIf="outgoingChecked">
                    <div class="p-col-12">
                        <div class="p-d-flex">
                            <label class="p-mr-2">Email</label>
                            <input type="text" pInputText />
                        </div>
                        <div class="p-d-flex p-mt-2">
                            <label class="p-mr-2">Password</label>
                            <input type="text" pInputText />
                        </div>
                    </div>
                </ng-container>
            </div>
        </p-panel>
    </div>
    <p-footer>
        <button type="button" class="p-button-secondary" pButton (click)="displaySMTPConfig=false" label="Cancel"></button>
        <button type="button" pButton label="Save"></button>
    </p-footer>
</p-dialog> -->

<!-- IMAP Refactor Design -->
<p-dialog [(visible)]="displaySMTPConfig" header="IMAP Account Settings" [modal]="true" [style]="{width: '45vw'}" [closable]="false">
    <ng-container *ngIf="smtpConfigIndex == 1;">
        <form [formGroup]="smtpSettingForm">
            <div class="card">
                <p-panel header="Incoming Mail">
                    <div class="p-grid incoming-mail-form">
                        <div class="p-col-12 p-md-7">
                            <div class="p-d-flex">
                                <label for="incomingServer" class="p-mr-2">Server<span style="color: red;">*</span></label>
                                <input type="text" pInputText formControlName="incomingServer" />
                            </div>
                            <div *ngIf="detailsFormErrors?.incomingServer" class="p-invalid">
                                <small>{{ detailsFormErrors?.incomingServer }}</small>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-5">
                            <div class="p-d-flex">
                                <label for="incomingPort" class="p-mr-2">Port<span style="color: red;">*</span></label>
                                <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false" formControlName="incomingPort" >
                                </p-inputNumber>
                            </div>
                            <div *ngIf="detailsFormErrors?.incomingPort" class="p-invalid">
                                <small>{{ detailsFormErrors?.incomingPort }}</small>
                            </div>
                        </div>

                        <ng-container>
                            <div class="p-col-12 p-md-7">
                                <div class="form-group">
                                    <div class="p-d-flex">
                                        <label for="incomingEmail" class="p-mr-2">Email<span style="color: red;">*</span></label>
                                        <input type="text" pInputText  formControlName="incomingEmail" />
                                    </div>
                                    <div *ngIf="detailsFormErrors?.incomingEmail" class="p-invalid">
                                        <small>{{ detailsFormErrors?.incomingEmail }}</small>
                                    </div>
                                </div>
                                </div>
                                <div class="p-col-12 p-md-5">
                                    <div class="form-group mt-2">
                                        <div class="p-d-flex p-mt-1">
                                            <label for="incomingPassword" class="p-mr-2">Password<span style="color: red;">*</span></label>
                                            <p-password class="w-100" styleClass="w-100" [toggleMask]="true" [feedback]="false" formControlName="incomingPassword" />
                                        </div>
                                        <div *ngIf="detailsFormErrors?.incomingPassword" class="p-invalid">
                                            <small>{{ detailsFormErrors?.incomingPassword }}</small>
                                        </div>
                                    </div>
                                </div>
                        </ng-container>
                    </div>
                </p-panel>
                <p-panel header="Outgoing Mail">
                    <div class="p-grid outgoing-mail-form">
                        <div class="p-col-12 p-md-7">
                            <div class="p-d-flex">
                                <label for="outgoingServer" class="p-mr-2">Server<span style="color: red;">*</span></label>
                                <input type="text" pInputText  formControlName="outgoingServer"/>
                            </div>
                            <div *ngIf="detailsFormErrors?.outgoingServer" class="p-invalid">
                                <small>{{ detailsFormErrors?.outgoingServer }}</small>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-5">
                            <div class="p-d-flex">
                                <label for="outgoingPort"  class="p-mr-2">Port<span style="color: red;">*</span></label>
                                <p-inputNumber mode="decimal" formControlName="outgoingPort" inputId="withoutgrouping" [useGrouping]="false">
                                </p-inputNumber>
                            </div>
                            <div *ngIf="detailsFormErrors?.outgoingPort" class="p-invalid">
                                <small>{{ detailsFormErrors?.outgoingPort }}</small>
                            </div>
                        </div>
                        <ng-container>
                            <div class="p-col-12 p-md-7">
                                <div class="form-group">
                                    <div class="p-d-flex">
                                        <label for="outgoingEmail" class="p-mr-2">Email<span style="color: red;">*</span></label>
                                        <input type="text" pInputText  formControlName="outgoingEmail" />
                                    </div>
                                    <div *ngIf="detailsFormErrors?.outgoingEmail" class="p-invalid">
                                        <small>{{ detailsFormErrors?.outgoingEmail }}</small>
                                    </div>
                                </div>
                                </div>
                                <div class="p-col-12 p-md-5">
                                    <div class="form-group mt-2">
                                        <div class="p-d-flex p-mt-1">
                                            <label for="outgoingPassword" class="p-mr-2">Password<span style="color: red;">*</span></label>
                                            <p-password class="w-100" styleClass="w-100" [toggleMask]="true" [feedback]="false" formControlName="outgoingPassword" />
                                        </div>
                                        <div *ngIf="detailsFormErrors?.outgoingPassword" class="p-invalid">
                                            <small>{{ detailsFormErrors?.outgoingPassword }}</small>
                                        </div>
                                    </div>
                                </div>
                        </ng-container>
                    </div>
                </p-panel>
            </div>
        </form>
    </ng-container>
    <div class="card" *ngIf="smtpConfigIndex == 2;">
        <div class="p-text-center">
            <h3>Verified</h3>
            <p>Please click on "Save" to complete SMTP configuration.</p>
        </div>
    </div>
    <p-footer>
        <button type="button" class="p-button-secondary" pButton (click)="onCancelSmtpPopup()" label="Cancel"></button>
        <button type="button" pButton label="Next" (click)="verifySmtp()" *ngIf="smtpConfigIndex == 1"></button>
        <button type="button" pButton label="Save" (click)="saveSmtpConfig()" *ngIf="smtpConfigIndex == 2"></button>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="displayChangeUser" header="Change User" [modal]="true" [style]="{width: '25vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-3">
                <label class="p-mr-2">Email</label>
            </div>
            <div class="p-col-9">
                <input type="text" pInputText />
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-3">
                <label class="p-mr-2">Password</label>
            </div>
            <div class="p-col-9">
                <input type="text" pInputText />
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" class="p-button-secondary" pButton (click)="displayChangeUser=false" label="Cancel"></button>
        <button type="button" pButton label="Save"></button>
    </p-footer>
</p-dialog>
